import { IModuleInfo } from './moduleInterface'


export interface IModule {
    modules: IModuleInfo[]
    activeIndex: number
    runningIndex: number
}

export interface IModuleAction {
    type: string,
    payload?: {
        modules?: IModuleInfo[],
        activeIndex?: number
        runningIndex?: number
    }
}

const moudlesDefault: IModule = {
    modules: [],
    activeIndex: 0,
    runningIndex: 0
}


function moduleReducer(state: IModule = moudlesDefault, action: IModuleAction): IModule {

    switch (action.type) {
        case "UPDATE_MODULE":
            return Object.assign({}, state, action.payload)
            case "PROGRESS_CLEAR":
                return moudlesDefault;
        default:
            return state;

    }
}

export default moduleReducer;
